import e from "react";
import r from "@appchoose/cn";
import g from "@appchoose/icon";
import * as l from "@radix-ui/react-dialog";
const f = e.forwardRef(
  ({
    type: t = "button",
    appearance: o = "primary",
    size: d = "medium",
    containsIcon: s = !1,
    children: c,
    className: m,
    ...p
  }, u) => {
    const n = (a) => r(
      "inline-flex items-center font-bold transition-colors duration-300 outline-none focus-visible:ring-2 focus-visible:ring-gray-900/30 disabled:cursor-not-allowed",
      {
        rounded: d === "small",
        "rounded-lg": d !== "small",
        "bg-red-600 border-red-600 text-white hover:bg-red-375 hover:border-red-375 disabled:bg-red-300 disabled:border-red-300": a === "danger",
        "bg-gray-900 border-gray-900 text-white hover:bg-gray-700 hover:border-gray-700 disabled:bg-gray-300 disabled:border-gray-300": !a || a === "primary",
        "bg-white text-gray-900 border-gray-900 hover:text-gray-700 hover:border-gray-700 disabled:text-gray-300 disabled:border-gray-300": a === "outline"
      }
    ), i = (a) => r({
      border: a === "small",
      "border-2": a !== "small",
      "text-xs p-1.75": (!a || a === "small") && s,
      "text-xs px-2.5 py-1.75": (!a || a === "small") && !s,
      "text-sm px-3.5 py-2": (!a || a === "medium") && !s,
      "text-sm p-1.5": (!a || a === "medium") && s,
      "text-md px-9.5 py-3.5": a === "large" && !s,
      "text-md p-4": a === "large" && s
    });
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        ref: u,
        type: t,
        className: r(
          n(o),
          i(d),
          m
        ),
        ...p
      },
      c
    );
  }
);
f.displayName = "Button";
const b = e.createContext({
  modal: !1
}), O = ({
  modal: t = !1,
  ...o
}) => /* @__PURE__ */ e.createElement(
  b.Provider,
  {
    value: e.useMemo(() => ({ modal: t }), [t])
  },
  /* @__PURE__ */ e.createElement(l.Root, { ...o, modal: t })
), y = l.Trigger, v = l.Close, N = l.Portal, x = e.forwardRef(({ className: t, ...o }, d) => e.useContext(b).modal ? /* @__PURE__ */ e.createElement(
  l.Overlay,
  {
    ref: d,
    className: `fixed inset-0 z-40 bg-black/30 data-[state=closed]:duration-300 data-[state=open]:duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 ${t ?? ""}`,
    ...o
  }
) : /* @__PURE__ */ e.createElement(y, { asChild: !0 }, /* @__PURE__ */ e.createElement(
  "div",
  {
    className: `fixed inset-0 z-40 bg-black/30 data-[state=closed]:duration-300 data-[state=open]:duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 ${t ?? ""}`,
    "data-state": "open",
    ref: d
  }
)));
x.displayName = l.Overlay.displayName;
const h = e.forwardRef(
  ({
    children: t,
    className: o,
    hideCloseButton: d,
    scrollable: s,
    onFocusOutside: c,
    onPointerDownOutside: m,
    ...p
  }, u) => {
    const n = e.useContext(b);
    return /* @__PURE__ */ e.createElement(N, null, /* @__PURE__ */ e.createElement(x, null), /* @__PURE__ */ e.createElement(
      l.Content,
      {
        ref: u,
        "data-no-modal": !n.modal,
        className: r(
          "modal-content fixed left-[50%] top-[50%] z-40 mx-auto grid w-full max-w-2.5xl translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg bg-white data-[state=closed]:duration-200 data-[state=open]:duration-300 data-[state=closed]:ease-out-cubic data-[state=open]:ease-in-cubic data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
          s ? "h-[calc(100vh_-_120px)] max-h-[37.5rem]" : "",
          o
        ),
        ...p,
        onPointerDownOutside: m ?? (n.modal ? void 0 : (i) => i.preventDefault()),
        onFocusOutside: c ?? (n.modal ? void 0 : (i) => i.preventDefault())
      },
      t,
      !d && /* @__PURE__ */ e.createElement(
        v,
        {
          className: "absolute bottom-[calc(100%+0.5rem)] right-0",
          asChild: !0
        },
        /* @__PURE__ */ e.createElement(f, { type: "button", containsIcon: !0 }, /* @__PURE__ */ e.createElement(g, { icon: "close", size: "large", className: "text-white" }))
      )
    ));
  }
);
h.displayName = l.Content.displayName;
const E = e.forwardRef(({ className: t, ...o }, d) => /* @__PURE__ */ e.createElement(
  l.Title,
  {
    ref: d,
    className: r("text-2xl font-bold text-gray-900", t),
    ...o
  }
));
E.displayName = l.Title.displayName;
const w = e.forwardRef(({ className: t, ...o }, d) => /* @__PURE__ */ e.createElement(
  l.Description,
  {
    ref: d,
    className: `${t ?? ""}`,
    ...o
  }
));
w.displayName = l.Description.displayName;
const M = ({
  className: t,
  ...o
}) => /* @__PURE__ */ e.createElement("div", { className: r("mb-4", t), ...o });
M.displayName = "ModalHeader";
const C = ({
  className: t,
  ...o
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: r(
      "flex flex-shrink-0 justify-end space-x-6 border-t border-gray-100 p-6 md:p-10 md:pt-6",
      t
    ),
    ...o
  }
);
C.displayName = "ModalFooter";
export {
  O as Modal,
  v as ModalClose,
  h as ModalContent,
  w as ModalDescription,
  C as ModalFooter,
  M as ModalHeader,
  x as ModalOverlay,
  E as ModalTitle,
  y as ModalTrigger
};
